
import aliasb03645cf6abd4d56a73b13687765a5d8 from '@/locale/i18nUtils.js';
import Vue from 'vue';
import axios from 'axios';
import {LoadingBar, Modal} from 'view-design';
import {removeToken, getToken} from '@/utils/cookie';
import MSG from './message/message/index';
import {
  showNoAuth,
  supplierDeactivationPrompt,
  auditSuppliers,
  becomeDistributor,
  noDomainNameSite, insufficientInventory, showShoppingPerfectInformation
} from '@/utils/asist';
import {showLoadingModal, hideLoadingModal} from '@/utils/loading';
import {publicExceptionCodes} from "@/config/exceptionCode";
import '@/locale/method/locale';
import {pageJump, deleteTicket, commonSessionStorage, EventBus, getSetLanguages, markInterceptorHandled} from "@/utils/common";
import store from '@/store/store';
import {dynamicErrorCodeFun} from "@/utils/dynamicErrorCode";
import regular from "@/utils/tools/regular";

// axios 配置
let pending = []; // 声明一个数组用于存储每个ajax请求的取消函数和ajax标识
let CancelToken = axios.CancelToken;
let pendingTimer = null;
// 防止多次请求相同接口的处理方法
let removePending = (config, cancel) => {
  return new Promise(resolve => {
    if (config) {
      let params = '';
      clearTimeout(pendingTimer);
      if (config.data) {
        try {
          let obj = JSON.parse(config.data);
          params = JSON.stringify(obj);
        } catch (e) {
          params = JSON.stringify(config.data);
        }
      }
      if (config.url) {
        if (config.url.includes('fresh=KEEPNEW')) {
          for (let p in pending) {
            if (pending[p].u === config.url + '&' + config.method) {
              // 当当前请求在数组中存在时执行函数体
              let c = pending[p].cancel;
              c('cancelHttp');
              pending.splice(p, 1); // 把这条记录从数组中移除
              resolve(false);
              return;
            }
          }
        } else {
          for (let p in pending) {
            if (pending[p].u === config.url + '&' + config.method + '&' + params) {
              // 当当前请求在数组中存在时执行函数体
              cancel && cancel('cancelHttp');
              pending.splice(p, 1); // 把这条记录从数组中移除
              resolve(false);
              return;
            }
          }
        }
      }

      pendingTimer = setTimeout(() => {
        pending = [];
      }, 5000);
      resolve(true);
    }
  });
};
// 异常编码提示的方法
let showHttpErrorMessage = function (code) {
  let text = publicExceptionCodes(code);
  if (text) {
    setTimeout(() => {
      MSG.error({
        content: text,
        duration: 5,
        level: 1,
        closable: true
      });
    }, 300);
  }
};

axios.defaults.timeout = 180000;
axios.defaults.baseURL = '';
axios.defaults.responseType = 'json';
axios.defaults.headers.post['Accept'] = 'application/json;';
axios.defaults.headers.post['Content-Type'] = 'application/json;';
axios.defaults.headers.delete['X-Requested-With'] = 'XMLHttpRequest';
axios.defaults.headers.delete['Accept'] = 'application/json;';
axios.defaults.headers.delete['Content-Type'] = 'application/json;';
axios.defaults.headers.put['Content-Type'] = 'application/json;';
axios.defaults.headers.put['Accept'] = 'application/json; ';
axios.defaults.headers.get['Content-Type'] = 'application/json;';
axios.defaults.headers.get['Accept'] = 'application/json; ';

var token = getToken() || commonSessionStorage.getItem('token'); // hack
// http request 拦截器
axios.jsonp = url => {
  if (!url) {
    return;
  }
  return new Promise((resolve, reject) => {
    window.printHandler = result => {
      resolve({
        data: result
      });
    };
    var JSONP = document.createElement('script');
    JSONP.type = 'text/javascript';
    JSONP.src = `${url}&callback=printHandler`;
    document.getElementsByTagName('head')[0].appendChild(JSONP);
    setTimeout(() => {
      document.getElementsByTagName('head')[0].removeChild(JSONP);
    }, 500);
  });
};
axios.interceptors.request.use(function (config) {
  config.cancelToken = new CancelToken(c => {
    removePending(config, c);
    let params = '';
    if (config) {
      if (config.data) {
        try {
          if (Object.prototype.toString.call(config.data) === '[object Array]') {
            if (config.data.length === 1) {
              params = JSON.stringify(config.data);
            }
          } else {
            var obj = JSON.parse(config.data);
            params = JSON.stringify(obj);
          }
        } catch (e) {
          params = JSON.stringify(config.data);
        }
      }
      if (config.url) {
        if (config.url.includes('fresh=KEEPNEW')) {
          pending.push({u: config.url + '&' + config.method, cancel: c});
        } else {
          pending.push({u: config.url + '&' + config.method + '&' + params, cancel: c});
        }
      }
    }
  });
  // 当请求中配置了loading：true，时，展示loading的遮罩层
 if (config.loading) {
    config.__loadingToken = 'axios_' + Date.now() + '_' + Math.random().toString(36).slice(2, 9);
    showLoadingModal(config.loadingText, config.__loadingToken);
  } else {
    LoadingBar.start();
  }
  if (config.noLanguage) {
    delete config.headers.Language;
  } else {
    config.headers.Language = getSetLanguages();
  }
  token = getToken() || commonSessionStorage.getItem('token');
  if (token) {
    // 根据noToken参数判断是否添加token，有些api接口中是不需要传token的
    if (!config.noToken) {
      config.headers.Authorization = token;
    }
  } else {
    console.log('---token值已过期');
  }
  return config;
}, function (err) {
  return Promise.reject(err);
});


// http response 拦截器
axios.interceptors.response.use(function (response) {
  LoadingBar.finish();
  removePending(response.config);
 if (response.config.loading) {
    hideLoadingModal(response.config.__loadingToken, response.status);
  }
  if (response.data) {
    const code = response.data.code;
    const handlers = {
      // 999998：没有权限
      999998: () => {
        if (response.config.headers['Authorization-Special'] !== 'no-Login') {
          removeToken().then(() => {
            // 登出时销毁webSocket
            if (Vue.prototype.$webSocket) {
              Vue.prototype.$webSocket.destroyWebSocket(true);
            }
            let path = window.location.href;
            sessionStorage.removeItem('token'); // hack
            path = deleteTicket(path);
            const loginUrl = response.data.others.loginUrl;
            let url = '';
            const reg = regular.checkHttps; // 判断当前链接是否完整的https://、http://链接地址
            if (loginUrl) {
              url = reg.test(loginUrl)
                ? loginUrl + encodeURIComponent(path)
                : window.location.origin + loginUrl + encodeURIComponent(path);
              window.location.href = url;
            }
          });
        }
        return response;
      },
      // 999996：用户尚未登录
      999996: () => {
        // 这里没有处理，保持原有结构
        return response;
      },
      // 999995：供应商停用提示框
      999995: () => {
        let system = localStorage.getItem('system');
        if (system === 'supplier') {
          supplierDeactivationPrompt();
        } else {
          showNoAuth();
        }
        return response;
      },
      // 999993：展示后台的message
      999993: () => {
        MSG.error({
          content: response.data.message,
          duration: 5,
        });
        return response;
      },
      // 999992：没有权限（通途用户访问）
      999992: () => {
        showNoAuth();
        return response;
      },
      // 111314：当前登录分销商系统是通途商户，弹出是否要开通分销商的确认弹窗
      111314: () => {
        let message = response.data.message;
        localStorage.setItem('merchantId', message);
        becomeDistributor('tongTool');
        return response;
      },
      // 999990：校验信息提示--完善手机号、币种
      999990: () => {
        let href = window.location.href;
        if (href.includes('/distributor.html')) {
          store.commit('showPerfectInformation', new Date().getTime());
        }
        if (href.includes('/index.html')) {
          showShoppingPerfectInformation();
        }
        store.commit('improveMobileOrCurrency', true);
        return response;
      },
      // 1113022：校验信息提示--完善手机号
      1113022: () => {
        let href = window.location.href;
        if (href.includes('/distributor.html')) {
          store.commit('showPerfectInformation', new Date().getTime());
        }
        if (href.includes('/index.html')) {
          showShoppingPerfectInformation();
        }
        store.commit('improveMobile', true);
        return response;
      },
      // 1113023：校验信息提示--完善币种
      1113023: () => {
        let href = window.location.href;
        if (href.includes('/distributor.html')) {
          store.commit('showPerfectInformation', new Date().getTime());
        }
        if (href.includes('/index.html')) {
          showShoppingPerfectInformation();
        }
        store.commit('improveCurrency', true);
        return response;
      },
      // 111300：当前登录商户不是分销商，弹出是否要开通分销商的确认弹窗
      111300: () => {
        let merchantId = response.data.message;
        localStorage.setItem('merchantId', merchantId);
        becomeDistributor('distributor');
        return response;
      },
      // 1112793：当前登录商户不是供应商，弹出是否要开通供应商的确认弹窗
      1112793: () => {
        let merchantId = response.data.message;
        localStorage.setItem('merchantId', merchantId);
        becomeDistributor('supplier');
        return response;
      },
      // 210034：校验当前登录的供应商是否已经审核通过
      210034: () => {
        auditSuppliers(response.data.message);
        return response;
      },
      // 1112832：当前商户没有开通域名站点
      1112832: () => {
        noDomainNameSite(response.data.message);
        return response;
      },
      // 创建备货单包含定制商品的异常提示
      1112963: () => {
        let message = response.data.message || response.data.others.errorMessage;
        EventBus.$emit('initAbnormalStockingOfGoodsData', message);
        return response;
      },
      // 定制商品设计重复异常提示
      1112974: () => {
        let message = response.data.message || response.data.others.errorMessage;
        EventBus.$emit('initCustomizedProductDesignRepetitionData', message);
        return response;
      },
      999999: () => {
        // 999999：系统级错误
        showHttpErrorMessage(response.data.code);
        return response;
      },
      0: () => {
        // 0：正常返回
        return response;
      },
      122006: () => {
        // 122006：商品不存在，跳转到商城首页
        pageJump('/index.html#/index', '/yms-shopping-service', '_self');
        return response;
      },
      // 下单库存不足的校验提示
      1112955: () => {
        insufficientInventory(response.data.others);
        return response;
      }
    };

    // 处理一部分错误码范围
    const errorCodes = [-1, -2, -3, -4, -5, -6, -7, -8, -9, -10, 1111, -999, 1];
    if (handlers.hasOwnProperty(code)) {
      markInterceptorHandled();
      const result = handlers[code]();
      if (result !== undefined) return result;
    } else if (errorCodes.includes(code)) {
      // 这些错误码保持原样，不处理
      return response;
    } else {
      // 未定义或特殊错误码，执行默认处理
      const text = dynamicErrorCodeFun(response.data);
      if (text) {
        setTimeout(() => {
          MSG.error({
            content: text,
            duration: 5,
            level: 1,
            closable: true,
          });
        }, 300);
      } else {
        showHttpErrorMessage(code);
      }
      return response;
    }
  }
}, (error) => {
  if (error.config?.loading) {
    hideLoadingModal(error.config.__loadingToken, error.response?.status || 200);
  }
  if (error.response) {
    if (error.response.status === 500) {
      showHttpErrorMessage(error.response.data.code);
      return error.response;
    } else if (error.response.status === 504) {
      MSG.error({
        content: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1001690'),
        duration: 5,
        level: 1,
        closable: true
      });
    }
  } else if (error.message === 'cancelHttp') {
    // 取消
    return {
      data: {
        code: 10555555
      }
    };
  } else if (error.request) {
    console.log(error.request);
  } else {
    console.log('Error', error.message);
  }
  removePending(error.config);
});


